import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// ===================== DB TYPES =====================

export interface DbProfil {
  id: string;
  email: string | null;
  ad_soyad: string;
  rol: 'yonetici' | 'ogretmen';
  telefon: string | null;
  aktif: boolean;
  olusturma_tarihi: string;
}

export interface DbOgretmen {
  id: string;
  profil_id: string | null;
  ad_soyad: string;
  telefon: string | null;
  email: string | null;
  branslar: string[];
  sinif_seviyeleri: string[];
  online_ders: boolean;
  yuz_yuze_ders: boolean;
  musaitlik_notu: string | null;
  varsayilan_ders_ucreti: number;
  hakedis_orani: number;
  aktif: boolean;
  aciklama: string | null;
  olusturma_tarihi: string;
}

export interface DbOgrenci {
  id: string;
  ogrenci_adi: string;
  veli_adi: string | null;
  telefon: string | null;
  sehir: string;
  sinif: string | null;
  branslar: string[];
  ders_tipi: string | null;
  atanan_ogretmen_id: string | null;
  hedef: string | null;
  aktif: boolean;
  toplam_ders_sayisi: number;
  toplam_odeme: number;
  son_ders_tarihi: string | null;
  notlar: string | null;
  basvuru_id: string | null;
  olusturma_tarihi: string;
}

export interface DbBasvuru {
  id: string;
  basvuru_tarihi: string;
  ogrenci_adi: string;
  veli_adi: string | null;
  telefon: string;
  sehir: string;
  sinif: string | null;
  talep_edilen_ders: string | null;
  hedef: string | null;
  ders_tipi: string | null;
  kaynak: string | null;
  durum: string;
  notlar: string | null;
  ogrenci_id: string | null;
  olusturma_tarihi: string;
}

export interface DbDenemeDersi {
  id: string;
  ogrenci_id: string;
  ogretmen_id: string;
  yonlendirme_id: string | null;
  brans: string | null;
  planlanan_tarih: string | null;
  planlanan_saat: string | null;
  planlanan_sure: string | null;
  gerceklesen_sure: string | null;
  durum: string;
  sonuc: string | null;
  veli_memnun: boolean | null;
  ogrenci_devam_istiyor: boolean | null;
  tavsiye_edilen_haftalik_ders: number | null;
  ogretmen_degerlendirme_notu: string | null;
  yoneticiye_not: string | null;
  olusturma_tarihi: string;
}

export interface DbAktifDers {
  id: string;
  ogrenci_id: string;
  ogretmen_id: string;
  brans: string | null;
  ders_tarihi: string;
  ders_saati: string | null;
  ders_suresi: number;
  islenen_konu: string | null;
  odev_verildi: boolean;
  odev_aciklamasi: string | null;
  mini_sinav: boolean;
  sinav_sonucu: string | null;
  ogrenci_performans_notu: string | null;
  tekrar_konusu: string | null;
  veli_bilgilendirildi: boolean;
  ders_durumu: string;
  odeme_durumu: string;
  ek_aciklama: string | null;
  olusturma_tarihi: string;
}

export interface DbOdeme {
  id: string;
  ogrenci_id: string;
  ogretmen_id: string;
  dekont_tarihi: string;
  tutar: number;
  kac_derslik: number;
  aciklama: string | null;
  dekont_gorsel_url: string | null;
  odeme_durumu: string;
  yonetici_onay: boolean;
  yonetici_onay_tarihi: string | null;
  ogretmen_payi: number | null;
  platform_payi: number | null;
  hakedis_orani: number;
  olusturma_tarihi: string;
}

export interface DbGrupDersi {
  id: string;
  grup_adi: string;
  brans: string;
  seviye: string;
  ogretmen_id: string | null;
  maksimum_kontenjan: number;
  ders_gunleri: string[] | null;
  ders_saati: string | null;
  grup_ders_ucreti: number | null;
  baslangic_tarihi: string | null;
  bitis_tarihi: string | null;
  aciklama: string | null;
  durum: string;
  olusturma_tarihi: string;
}

export interface DbDersNotu {
  id: string;
  ogrenci_id: string;
  ogretmen_id: string;
  ders_id: string | null;
  not_tipi: string;
  not_metni: string;
  basari_durumu: string | null;
  not_tarihi: string;
  olusturma_tarihi: string;
}

export interface DbHakEdisOdemesi {
  id: string;
  ogretmen_id: string;
  odeme_tarihi: string;
  odeme_tutari: number;
  donem_baslangic: string | null;
  donem_bitis: string | null;
  aciklama: string | null;
  odeme_durumu: string;
  olusturma_tarihi: string;
}